import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ContextProviderBot } from './context/FlowContext';
import { ContextProviderUser } from './context/UserContext';
import { ContextProviderWatson } from './context/WatsonContext';
import { ContextProviderSave } from './context/SaveContext';
import { ContextProviderChatbotTesting } from './context/ChatbotTestingContext';
import { ContextProviderKnowledgeBases } from './context/KnowledgeBasesContext';

ReactDOM.render(
  <React.StrictMode>
    <ContextProviderSave>
      <ContextProviderBot>
        <ContextProviderUser>
          <ContextProviderWatson>
            <ContextProviderChatbotTesting>
              <ContextProviderKnowledgeBases>
                <BrowserRouter basename="/curadoria">
                  <App />
                </BrowserRouter>
              </ContextProviderKnowledgeBases>
            </ContextProviderChatbotTesting>
          </ContextProviderWatson>
        </ContextProviderUser>
      </ContextProviderBot>
    </ContextProviderSave>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
